import { useRouter } from "next/router";
import { useEffect, useState } from "react";

import { useConfig } from "../../useConfig";
import useToken from "../../useToken";
import usePaymentStore from "./usePaymentStore";

const usePaymentCallback = () => {
  const [checkoutScript, setCheckoutScript] = useState("");
  const [checkoutScriptLoaded, setCheckoutScriptLoaded] = useState(false);
  const [error, setError] = useState("");
  const { config } = useConfig();
  const { token: local_token } = useToken();
  const apiUrl = config?.centra?.url;
  const router = useRouter();
  const setPaymentResult = usePaymentStore((store) => store.setPaymentResult);
  const locale = router.locale;

  useEffect(() => {
    async function initCheckout(origdata: any) {
      const postData = origdata.detail;

      const response = await fetch(`${apiUrl}/payment`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "API-Token": local_token,
        },
        body: JSON.stringify({
          paymentMethod: postData.paymentMethod,
          address: postData.address ?? postData.billingAddress,
          shippingAddress: postData.shippingAddress,
          termsAndConditions: true,
          paymentReturnPage: `${origin}${config?.giftCardUrl}`,
          paymentFailedPage: `${origin}${config?.giftCardUrl}`,
          paymentMethodSpecificFields: postData.paymentMethodSpecificFields,
        }),
      });

      const data = await response.json();

      if (data?.errors) {
        setError("Payment error: Please try again with another payment method");
      }
      if (data.action === "success") {
        setPaymentResult(data.data);
        router.push(
          `${config?.root}/${locale}/giftcard/success?redirectResult=success`
        );
      }
      if (data) {
        setCheckoutScriptLoaded(true);
        setPaymentResult(data.data);
        setCheckoutScript(`<script> ${data.code} </script>`);
      }
    }
    document.addEventListener("centra_checkout_payment_callback", initCheckout);

    return () => {
      document.removeEventListener(
        "centra_checkout_payment_callback",
        initCheckout
      );
    };
  }, [apiUrl, local_token, router.push]);
  return {
    code: checkoutScript,
    error,
    loaded: checkoutScriptLoaded,
  };
};
export default usePaymentCallback;
